import { readSheet } from 'read-excel-file/browser';

export async function xlsxFileParser(file) {
  const rows = await readSheet(file);

  if (!rows.length) return [];

  const [headers, ...data] = rows;

  return data.map((row) => {
    return Object.fromEntries(
      headers.map((header, index) => [header, row[index]]),
    );
  });
}
